<template>
  <div class="app-router">
    <h2 class="font-weight-bold pb-5">{{ title }}</h2>
    <div class="d-block text-subtitle-2 pb-3">
      Pastikan produk Anda sudah sesuai dengan syarat dan ketentuan. Kami menghimbau seller untuk
      menjual produk dengan harga yang wajar atau produk Anda dapat diturunkan sesuai S&K yang
      berlaku.
    </div>
    <!-- {{produkInput}} -->
    <v-form ref="formUpdateProduct" role="form" v-if="detailStore" @submit="onSubmit">
      <v-card outlined class="px-3 py-3 my-5">
        <v-card-title class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4">
          Upload Gambar Produk
          <v-chip small class="ma-2" color="green" outlined>Wajib</v-chip>
        </v-card-title>
        <v-card-text class="px-2">
          <div class="text-caption">
            Format gambar .jpg .jpeg .png dan ukuran minimum 300 x 300 px (Untuk gambar optimal
            gunakan minimum 700 x 700 px). Maksimal ukuran file 2MB.
          </div>
          <div class="text-center mt-3" v-if="image_alert">
            <v-alert class="white--text red lighten-1" dense dismissible @input="toggleAlert"
              v-model="image_alert">Produk harus disertai gambar</v-alert>
          </div>

          <v-row class="my-5 d-flex align-center justify-center flex-row">
            <v-col cols="4" sm="2" v-for="(img, idg) in imgUbahProduct" :key="idg">
              <div class="product-img d-row outlined py-4 px-4" :class="img ? '' : 'emptyImg'">
                <v-img width="100%" :src="img ? img : '/assets/seller/add-image-icon.svg'"></v-img>
                <v-btn v-if="img && detailProduct.product_image.length > 1" class="mx-0 close-btn" fab dark x-small
                  color="red" @click="removeImage(idg, img)">
                  <v-icon dark>mdi-close</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>

          <div v-show="false">
            <v-file-input @change="createImage($event)" id="inputProdukImg" ref="fileupload" chips accept="image/*"
              multiple small-chips prepend-icon truncate-length="50"></v-file-input>
          </div>
          <div class="v-row d-flex flex-column align-center">
            <v-btn color="success" elevation="2" dark min-width="140" class="my-3" @click="openUpload">
              <strong class="text-capitalize text-subtitle-2 font-weight-bold">
                <v-icon color="white darken-1 mr-2">mdi-plus</v-icon>Pilih Gambar Produk
              </strong>
            </v-btn>

            <!-- <v-btn
              color="warning"
              elevation="2"
              dark
              min-width="140"
              class="my-3"
              v-else
            >
              <strong class="text-capitalize text-subtitle-2 font-weight-bold"><v-icon color="white darken-1 mr-2">mdi-upload</v-icon> Upload Produk</strong>
            </v-btn>-->
            <div class="text-caption font-weight-bold">Letakkan hingga 5 gambar sekaligus disini.</div>
          </div>
        </v-card-text>
      </v-card>

      <v-card outlined class="px-3 py-3 my-5">
        <v-card-title class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4">Informasi
          Produk</v-card-title>
        <v-card-text class="px-2">
          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Nama Produk
                <v-chip x-small class="ma-2 py-2 font-weight-bold" color="green" outlined>Wajib</v-chip>
              </div>
              <p class="mb-0 text-caption grey--text">
                Nama min. 5 karakter, terdiri dari jenis produk, merek, dan keterangan seperti
                warna, bahan, atau tipe.
              </p>
            </v-col>
            <v-col cols="12" sm="8" class="pb0-xs">
              <v-text-field :rules="nameRules" v-model="produkInput.nama" :disabled="detailStore.store_is_b2b == 'true'"
                outlined small dense counter="70" placeholder="Masukkan nama produk"
                :error-messages="responseError.name" @focus="() => (responseError.name = '')"></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4" class="py-0">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Kategori
                <v-chip x-small class="ma-2 py-2 font-weight-bold" color="green" outlined>Wajib</v-chip>
              </div>
            </v-col>
            <v-col cols="12" sm="8" class="py-0">
              <v-autocomplete @change="getCategorySelected(produkInput.kategori)" :rules="categoryRules"
                v-model="produkInput.kategori" :disabled="detailStore.store_is_b2b == 'true'" :items="category"
                item-value="product_category_id" item-text="product_category_name" placeholder="Pilih Kategori"
                hide-details="auto" outlined dense :error-messages="responseError.category"
                @focus="() => (responseError.category = '')"></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card outlined class="px-3 py-3 my-5">
        <v-card-title class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4">Detail
          Produk</v-card-title>
        <v-card-text class="px-2 pb-0">
          <v-row v-if="false">
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">Kondisi</div>
            </v-col>
            <v-col cols="8">
              <v-radio-group v-model="produkInput.kondisi" hide-details="auto" row>
                <v-radio label="Baru" value="1"></v-radio>
                <v-radio label="Bekas" value="0"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">Satuan    
                <v-chip x-small class="ma-2 py-2 font-weight-bold" color="green" outlined>Wajib</v-chip></div>
            </v-col>
            <v-col cols="12" sm="8" class="pb0-xs">
              <v-autocomplete v-model="produkInput.unit" :items="units" :rules="unitRules" placeholder="Satuan"
                hide-details="auto" outlined dense :error-messages="responseError.unit"
                @focus="() => (responseError.unit = '')">
                <template v-slot:selection="{ item }">
                  <span class="text-capitalize">{{ item }}</span>
                </template>
                <template v-slot:item="{ item }">
                  <span class="text-capitalize">{{ item }}</span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">Deskripsi Produk    
                <v-chip x-small class="ma-2 py-2 font-weight-bold" color="green" outlined>Wajib</v-chip></div>
              <p class="mb-0 text-caption grey--text">
                Pastikan deskripsi produk memuat spesifikasi, ukuran, bahan, masa berlaku, dan
                lainnya. Semakin detail, semakin berguna bagi pembeli.
              </p>
            </v-col>
            <v-col cols="12" sm="8" class="pb0-xs">
              <v-textarea v-model="produkInput.deskripsi" :rules="required" outlined small dense no-resize rows="5" counter="2000"
                :error-messages="responseError.description"
                @focus="() => (responseError.description = '')"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card outlined class="px-3 py-3 my-5" v-show="(produkInput.is_varian == '0') ? true : false">
        <v-card-title class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4">Harga
          Produk</v-card-title>
        <v-card-text class="px-2">
          <v-row v-if="false">
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">Minimum Pemesanan</div>
              <p class="mb-0 text-caption grey--text">Atur jumlah minimum yang harus dibeli untuk produk ini.</p>
            </v-col>
            <v-col cols="12" sm="4" class="pb0-xs">
              <v-text-field v-model="produkInput.minOrder" outlined small dense hide-details="auto"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Harga Satuan
                <v-chip x-small class="ma-2 py-2 font-weight-bold" color="green" outlined>Wajib</v-chip>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="pb0-xs">
              <v-currency-field @change="calculatePrice" v-model="produkInput.product_gross" :rules="priceRules"
                outlined small dense placeholder="Masukkan harga" prefix="Rp" hide-details="auto"
                :error-messages="responseError.price" @focus="() => (responseError.price = '')" persistent-hint
                hint="Harga jual produk ke konsumen"></v-currency-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">Diskon Produk</div>
            </v-col>
            <v-col cols="12" sm="2" class="pb0-xs">
              <v-switch @change="isEnableDiscount" v-model="produkInput.product_enable_discount" class="my-0 py-0" inset
                hide-details="auto" true-value="1" false-value="0" dense></v-switch>
            </v-col>
          </v-row>
          <v-row v-show="produkInput.product_enable_discount == 1">
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">Tipe Diskon</div>
            </v-col>
            <v-col cols="12" sm="2" class="pb0-xs">
              <v-radio-group v-model="produkInput.product_discount_type" hide-details="auto" row class="my-0"
                @change="calculatePrice">
                <v-radio label="Nominal" value="nominal"></v-radio>
                <v-radio label="Persentase" value="percent"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row v-show="produkInput.product_enable_discount == 1 &&
      produkInput.product_discount_type == 'percent'
      ">
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Persentase Diskon
                <v-chip x-small class="ma-2 py-2 font-weight-bold" color="green" outlined>Wajib</v-chip>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="pb0-xs">
              <v-currency-field @change="calculatePrice" :maxlength="3" :max="70"
                v-model="produkInput.product_discount_percent" :rules="valueRules" outlined small dense
                placeholder="Masukkan persentase diskon" prefix="%" hide-details="auto"
                :error-messages="responseError.price" @focus="() => (responseError.price = '')" persistent-hint
                hint="Maksimal 70%"></v-currency-field>
            </v-col>
          </v-row>
          <v-row v-show="produkInput.product_enable_discount == 1 &&
      produkInput.product_discount_type == 'nominal'
      ">
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Nominal Diskon
                <v-chip x-small class="ma-2 py-2 font-weight-bold" color="green" outlined>Wajib</v-chip>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="pb0-xs">
              <v-currency-field @change="calculatePrice" v-model="produkInput.product_discount_nominal"
                :rules="valueRules" outlined small dense placeholder="Masukkan nominal diskon" prefix="Rp"
                hide-details="auto" :error-messages="responseError.price" @focus="() => (responseError.price = '')"
                persistent-hint hint="Nilai nominal diskon maks 70% dari harga satuan"></v-currency-field>
            </v-col>
          </v-row>
          <v-row v-show="produkInput.product_enable_discount == 1">
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Harga Akhir
                <!-- <v-chip x-small class="ma-2 py-2 font-weight-bold" color="blue" outlined></v-chip> -->
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="pb0-xs">
              <v-currency-field :readonly="true" v-model="produkInput.hargaSatuan" :rules="priceRules" outlined small
                dense placeholder="Masukkan harga" prefix="Rp" hide-details="auto" :error-messages="responseError.price"
                @focus="() => (responseError.price = '')" persistent-hint hint="Dihitung otomatis"></v-currency-field>
            </v-col>
          </v-row>

          <v-row v-if="detailStore.store_is_b2b == 'true'">
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Harga B2B
                <v-chip x-small class="ma-2 py-2 font-weight-bold" color="green" outlined>Wajib</v-chip>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="pb0-xs">
              <v-currency-field v-model="produkInput.hargaB2b" :rules="priceB2bRules" outlined small dense
                placeholder="Masukkan harga" prefix="Rp" hide-details="auto"
                :error-messages="responseError.price_original" @focus="() => (responseError.price_original = '')"
                persistent-hint hint="Harga jual dari perusahaan"></v-currency-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <!-- <v-card outlined class="px-3 py-3 my-5" v-if="detailStore"> -->
      <v-card outlined class="px-3 py-3 my-5" v-show="false">
        <v-card-title class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4">Biaya
          Layanan
          Produk</v-card-title>
        <v-card-text class="px-2">
          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Persentase
                <v-chip x-small class="ma-2 py-2 font-weight-bold" color="green" outlined>Wajib</v-chip>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="pb0-xs">
              <!-- <v-select
                :rules="valueRules"
                v-model="produkInput.product_fee"
                :items="biayaLayananList"
                item-text="title"
                item-value="value"
                placeholder="Pilih Biaya Layanan"
                hide-details="auto"
                :auto-select-first="true"
                outlined
                dense
                :error-messages="responseError.product_fee"
                @focus="() => responseError.product_fee=''"
              ></v-select>
              <small class="text-muted">Biaya layanan menentukan Cashback untuk pelanggan Anda</small>-->
              <v-text-field :readonly="true" :rules="valueRules" v-model="produkInput.product_fee" outlined small dense
                placeholder="Biaya Layanan" :error-messages="responseError.product_fee"
                @focus="() => (responseError.product_fee = '')"></v-text-field>
              <small class="text-muted">Biaya layanan berdasarkan Kategori Produk.</small>
            </v-col>
            <v-col cols="12" sm="6" class="pb0-xs">
              <small v-if="selectedCategoryArr.product_category_fee_minimum > 0">
                Produk akan otomatis tayang jika biaya layanan minimal senilai
                {{ selectedCategoryArr.product_category_fee_minimum * 1 }}%.
              </small>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card outlined class="px-3 py-3 my-5" >
        <v-card-title
          class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4"
        >Diskon Per Tipe Member</v-card-title>
        <v-card-text class="px-2">
          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">Status Diskon</div>
            </v-col>
            <v-col cols="12" sm="2" class="pb0-xs">
              <v-switch
                @change="isEnableDiscountTypeMember"
                v-model="produkInput.is_discount_tipe_member"
                class="my-0 py-0"
                inset
                hide-details="auto"
                true-value="1"
                false-value="0"
                dense
              ></v-switch>
            </v-col>
          </v-row>
          <v-row  v-show="produkInput.is_discount_tipe_member == 1">
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">Jenis Diskon Persen</div>
            </v-col>
            <v-col cols="12" sm="6" class="pb0-xs">
              <v-switch 
                v-model="produkInput.is_discount_tipe_member_percent"
                class="my-0 py-0"
                @change="resetDiscountMember"
                inset
                hide-details="auto"
                true-value="1"
                false-value="0"
                dense
                persistent-hint
                :hint="'Aktifkan untuk diskon persen, Nonaktifkan untuk diskon nominal'"
              ></v-switch>
            </v-col>
          </v-row>
          <template v-if="(produkInput.is_varian == '0') || (produkInput.is_varian == '1' && produkInput.is_discount_tipe_member == '1' && produkInput.is_discount_tipe_member_percent == '1')">
            <v-row v-for="(item,i) in memberType" :key="i" v-show="produkInput.is_discount_tipe_member == 1">
              <v-col cols="12" sm="4" class="pb0-xs">
                <div class="d-block text-subtitle-2 font-weight-bold black--text">
                   Diskon {{ item.label }}
                  <v-chip x-small class="ma-2 py-2 font-weight-bold" color="green" outlined>Wajib</v-chip>
                </div>
              </v-col>
              <v-col cols="12" sm="4" class="pb0-xs">
                <v-currency-field v-if="produkInput.is_discount_tipe_member_percent == '0'"
                  v-model="produkInput['discount_nominal_' + item.value]"
                  :rules="valueRules"
                  outlined
                  :max="Number(produkInput.product_gross)"
                  small
                  dense
                  :placeholder="'Masukkan nominal diskon ' + item.label"
                  prefix="Rp"
                  hide-details="auto"
                  :error-messages="responseError.price"
                  @focus="() => (responseError.price = '')"
                  persistent-hint
                  :hint="'Masukkan nominal diskon ' + item.label"
                ></v-currency-field>
                <v-currency-field  v-else
                  v-model="produkInput['discount_percent_' + item.value]"
                  :rules="valueRules"
                  :maxlength="3"
                  :max="100"
                  outlined
                  small
                  dense
                  :placeholder="'Masukkan persentase diskon '+ item.label"
                  suffix="%"
                  hide-details="auto"
                  :error-messages="responseError.price"
                  @focus="() => (responseError.price = '')"
                  persistent-hint
                  :hint="'Masukkan persentase diskon '+ item.label"
                ></v-currency-field> 
                <small class="ml-3">HJ {{ item.label }} : {{calculateDiscountPercent( `${produkInput.is_discount_tipe_member_percent == '0' ? 'discount_nominal_' : 'discount_percent_'}` + item.value)}}</small>
              </v-col>
            </v-row>
          </template>
          <!-- <v-row v-show="produkInput.is_discount_tipe_member == 1">
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Nominal Diskon Silver
                <v-chip x-small class="ma-2 py-2 font-weight-bold" color="green" outlined>Wajib</v-chip>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="pb0-xs">
              <v-currency-field 
                v-model="produkInput.discount_percent_silver"
                :rules="valueRules" 
                :maxlength="3"
                :max="70"
                outlined
                small
                dense
                placeholder="Masukkan persentase diskon Silver"
                suffix="%"
                hide-details="auto"
                :error-messages="responseError.price"
                @focus="() => (responseError.price = '')"
                persistent-hint
                hint="Nilai persentase diskon Silver"
              ></v-currency-field>
            </v-col>
          </v-row>
          <v-row v-show="produkInput.is_discount_tipe_member == 1">
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Nominal Diskon Gold
                <v-chip x-small class="ma-2 py-2 font-weight-bold" color="green" outlined>Wajib</v-chip>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="pb0-xs">
              <v-currency-field 
                v-model="produkInput.discount_percent_gold"
                :rules="valueRules"
                outlined
                small
                :maxlength="3"
                :max="70"
                dense
                placeholder="Masukkan persentase diskon Gold"
                suffix="%"
                hide-details="auto"
                :error-messages="responseError.price"
                @focus="() => (responseError.price = '')"
                persistent-hint
                hint="Nilai persentase diskon Gold"
              ></v-currency-field>
            </v-col>
          </v-row>
          <v-row v-show="produkInput.is_discount_tipe_member == 1">
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Nominal Diskon Platinum
                <v-chip x-small class="ma-2 py-2 font-weight-bold" color="green" outlined>Wajib</v-chip>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="pb0-xs">
              <v-currency-field 
                v-model="produkInput.discount_percent_platinum"
                :rules="valueRules"
                outlined
                small
                :maxlength="3"
                :max="70"
                dense
                placeholder="Masukkan persentase diskon Platinum"
                suffix="%"
                hide-details="auto"
                :error-messages="responseError.price"
                @focus="() => (responseError.price = '')"
                persistent-hint
                hint="Nilai persentase diskon Platinum"
              ></v-currency-field>
            </v-col>
          </v-row> -->
        </v-card-text>
      </v-card>
      <v-card outlined class="px-3 py-3 my-5" >
        <v-card-title
          class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4"
        >Diskon Nego</v-card-title>
        <v-card-text class="px-2">
          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">Status Nego</div>
            </v-col>
            <v-col cols="12" sm="2" class="pb0-xs">
              <v-switch
                @change="isEnableNego"
                v-model="produkInput.is_nego"
                class="my-0 py-0"
                inset
                hide-details="auto"
                true-value="1"
                false-value="0"
                dense
              ></v-switch>
            </v-col>
          </v-row>
          <v-row v-show="produkInput.is_nego == 1">
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Batas Maksimal Nego
                <v-chip x-small class="ma-2 py-2 font-weight-bold" color="green" outlined>Wajib</v-chip>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="pb0-xs">
              <v-currency-field 
                v-model="produkInput.discount_percent_nego"
                :rules="valueRules" 
                :maxlength="3"
                :max="100"
                outlined
                small
                dense
                placeholder="Masukkan persentase diskon nego"
                suffix="%"
                hide-details="auto"
                :error-messages="responseError.price"
                @focus="() => (responseError.price = '')"
                persistent-hint
                hint="Validasi otomatis dari sistem untuk nilai batas maksimal nego. Isi dengan angka 100% jika ingin tanpa limit nego"
              ></v-currency-field>
            </v-col>
          </v-row>
          
        </v-card-text>
      </v-card>
      <v-card outlined class="px-3 py-3 my-5">
        <v-card-title class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4">Pengelolaan
          Produk</v-card-title>
        <v-card-text class="px-2">
          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">Status Produk</div>
            </v-col>
            <v-col cols="12" sm="2" class="pb0-xs">
              <v-switch v-model="produkInput.status" class="my-0 py-0" inset hide-details="auto" true-value="active"
                false-value="inactive" dense></v-switch>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">Varian Produk</div>
            </v-col>
            <v-col cols="12" sm="2" class="pb0-xs">
              <v-switch v-model="produkInput.is_varian"  @change="showTable"  class="my-0 py-0" inset hide-details="auto" true-value="1"
                false-value="0" dense></v-switch>
            </v-col>
          </v-row>
          <v-row v-show="(produkInput.is_varian == '0') ? false : true">
            <v-col cols="12" sm="12" class="pb0-xs">
              <varian-table :isDiscountMemberEnable="produkInput.is_discount_tipe_member" :isDicountMemberPercent="produkInput.is_discount_tipe_member == '0' ? '0' : produkInput.is_discount_tipe_member_percent" v-model="produkInput.varian_arr" @checkVariantDiscount="checkVariantDiscount" @removedata="removeDataVariant"
              @updateData="updateDataVariant" /> <!-- <template>
                <v-table class="table">
                  <thead>
                    <tr>
                      <th class="text-center">
                        <v-checkbox color="red" hide-details></v-checkbox>
                      </th>
                      <td>
                        <p class="mb-0 text-caption grey--text"> 1 varian dipilih</p>
                      </td>
                      <td>
                        <v-btn color="red" outlined block>
                          <strong>Hapus</strong>
                        </v-btn>
                      </td>
                    </tr>
                    <tr>
                      <th class="text-center" colspan="3">
                        <p class="mb-0 text-caption grey--text"> Atur dan terapkan data varian</p>
                      </th>
                      <td>
                        <v-currency-field outlined small dense placeholder="Harga"></v-currency-field>
                      </td>
                      <td>
                        <v-currency-field outlined small dense placeholder="Stok"></v-currency-field>
                      </td>
                      <td>
                        <v-text-field outlined small dense placeholder="SKU"></v-text-field>
                      </td>
                      <td>
                        <v-currency-field outlined small dense placeholder="Berat"></v-currency-field>
                      </td>
                      <td>
                        <v-btn color="#272727" outlined block>
                          <strong>Terapkan</strong>
                        </v-btn>
                      </td>
                    </tr>
                    <tr>
                      <th class="text-center"></th>
                      <th class="text-center">Gambar</th>
                      <th>Nama</th>
                      <th>Harga</th>
                      <th>Stok</th>
                      <th>SKU</th>
                      <th>Berat (Gram)</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <v-checkbox color="red" hide-details></v-checkbox>
                      </td>
                      <td>
                        <v-file-input v-show="false" accept="image/*" id="inputImage" truncate-length="50" small-chips
                          outlined dense hide-details="auto" prepend-icon="" :clearable="false" placeholder=""
                          class="mt-md-3 text-body-2 rounded-lg file-button"></v-file-input>
                        <v-btn color="#272727" outlined block>
                          <strong>Gambar</strong>
                        </v-btn>
                      </td>
                      <td>
                        <v-text-field placeholder="Masukkan nama produk"></v-text-field>
                      </td>
                      <td>
                        <v-currency-field outlined small dense placeholder=""></v-currency-field>
                      </td>
                      <td>
                        <v-currency-field outlined small dense placeholder=""></v-currency-field>
                      </td>
                      <td>
                        <v-text-field outlined small dense placeholder=""></v-text-field>
                      </td>
                      <td>
                        <v-currency-field outlined small dense placeholder=""></v-currency-field>
                      </td>
                      <td>
                        <v-switch class="my-0 py-0" inset hide-details="auto"
                          true-value="1" false-value="0" dense></v-switch>
                      </td>

                    </tr>
                  </tbody>
                </v-table>
                <v-btn outlined>
                  <strong>Tambah Varian</strong>
                </v-btn>
              </template> -->
            </v-col>

          </v-row>
          <v-row v-show="(produkInput.is_varian == '0') ? true : false">
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Stok Produk
                <v-chip x-small class="ma-2 py-2 font-weight-bold" color="green" outlined>Wajib</v-chip>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="pb0-xs">
              <v-currency-field v-model="produkInput.stok" :rules="stockRules" outlined small dense
                placeholder="Masukkan jumlah stok" hide-details="auto" :error-messages="responseError.quantity"
                @focus="() => (responseError.quantity = '')"></v-currency-field>
            </v-col>
          </v-row>
          <v-row v-show="(produkInput.is_varian == '0') ? true : false">
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">SKU (Stock Keeping Unit)</div>
              <p class="mb-0 text-caption grey--text">Gunakan kode unik SKU jika kamu ingin menandai produkmu.</p>
            </v-col>
            <v-col cols="12" sm="4" class="pb0-xs">
              <v-text-field v-model="produkInput.code" outlined small dense placeholder="Masukkan Kode Produk"
                :error-messages="responseError.code" @focus="() => (responseError.code = '')"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card outlined class="px-3 py-3 my-5">
        <v-card-title class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4">Berat &amp; Pengiriman
          Produk</v-card-title>
        <v-card-text class="px-2">
          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Berat Produk
                <v-chip x-small class="ma-2 py-2 font-weight-bold" color="green" outlined>Wajib</v-chip>
              </div>
              <p class="mb-0 text-caption grey--text">Masukkan berat dengan menimbang produk setelah dikemas.</p>
            </v-col>

            <v-col cols="12" sm="3" class="pb0-xs">
              <v-autocomplete v-model="produkInput.unitberat" :items="weightUnits" :rules="weightUnitRules"
                item-text="text" item-value="multiple" placeholder="Satuan" hide-details="auto" outlined
                dense></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="3" class="pb0-xs" v-show="(produkInput.is_varian == '0') ? true : false">
              <v-currency-field v-model="produkInput.berat" :rules="weightRules" outlined small dense
                hide-details="auto" placeholder="Masukkan berat" :decimalLength="2"
                :error-messages="responseError.weight" @focus="() => (responseError.weight = '')"></v-currency-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">Ukuran Produk</div>
              <p class="mb-0 text-caption grey--text">Masukkan ukuran produk setelah dikemas untuk menghitung berat
                volume</p>
            </v-col>
            <v-col cols="12" sm="8" class="pb0-xs">
              <v-row>
                <v-col cols="12" sm="4" class="pb0-xs">
                  <v-currency-field :label="'Panjang (cm)'" v-model="produkInput.product_length" outlined small dense
                    :error-messages="responseError.product_length"
                    @focus="() => (responseError.product_length = '')"></v-currency-field>
                </v-col>
                <v-col cols="12" sm="4" class="pb0-xs">
                  <v-currency-field :label="'Lebar (cm)'" v-model="produkInput.product_width" outlined small dense
                    :error-messages="responseError.product_width"
                    @focus="() => (responseError.product_width = '')"></v-currency-field>
                </v-col>
                <v-col cols="12" sm="4" class="pb0-xs">
                  <v-currency-field :label="'Tinggi (cm)'" v-model="produkInput.product_height" outlined small dense
                    :error-messages="responseError.product_height"
                    @focus="() => (responseError.product_height = '')"></v-currency-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row v-if="false">
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">Asuransi Pengiriman</div>
              <p class="mb-0 text-caption grey--text">
                Gunakan asuransi pengiriman untuk menjamin kerugian, kerusakan, &amp; kehilangan
                selama pengiriman produk.
              </p>
            </v-col>
            <v-col cols="12" sm="8" class="pb0-xs">
              <v-radio-group v-model="produkInput.asuransi" hide-details="auto" row class="my-0">
                <v-radio label="Opsional" value="0"></v-radio>
                <v-radio label="Ya" value="1"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-form>

    <v-layout v-resize="onResize" column>
      <v-card outlined class="px-3 py-3 my-5">
        <v-card-text>
          <v-row>
            <v-col cols="12" class="text-right py-0 px-0">
              <v-btn color="error" elevation="2" outlined dark min-width="140" :loading="loadingProcess" class="mr-2"
                v-if="!isMobile" @click="cancelForm()">
                <strong class="text-capitalize text-subtitle-2 font-weight-bold">Batal</strong>
              </v-btn>

              <v-btn color="success" elevation="2" dark min-width="140" :loading="loadingProcess" @click="update"
                :class="isMobile ? 'v-btn--block mb-3' : ''">
                <strong class="text-capitalize text-subtitle-2 font-weight-bold">Simpan</strong>
              </v-btn>

              <v-btn color="error" elevation="2" outlined dark min-width="140" :loading="loadingProcess"
                :class="isMobile ? 'v-btn--block mb-3' : 'mr-2'" v-if="isMobile" @click="cancelForm()">
                <strong class="text-capitalize text-subtitle-2 font-weight-bold">Batal</strong>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-layout>
  </div>
</template>

<script>
import varianTable from "./components/varianTable.vue";
import { mapState, mapActions, mapMutations } from "vuex";
const defaultVarianArr = () => ({
  varian_name: "-",
  varian_stock_quantity: "0",
  varian_weight: "0",
  varian_price: "0",
  varian_code: "",
  varian_status: "active",
  is_main: "0",
  varian_image: null, 
  varian_discount_nominal_silver: 0,
      varian_discount_nominal_gold: 0,
      varian_discount_nominal_platinum: 0
});
const defaultInput = () => ({
nama: "",
  slug: "",
  kategori: "",
  kondisi: "1",
  deskripsi: "",
  minOrder: 0,
  hargaSatuan: "",
  hargaB2b: "",
  status: "active",
  stok: 0,
  berat: 0,
  unitberat: 1,
  unit: "",
  asuransi: 0,
  image: [],
  isMobile: false,
  product_gross: 0,
  product_enable_discount: 0,
  product_discount_type: "nominal",
  product_discount_percent: 0,
  product_discount_nominal: 0,
  is_discount_tipe_member: 0,
  discount_percent_silver: 0,
  is_discount_tipe_member_percent:'1', // 1 => persen , 0 => nominal 
  discount_nominal_silver: 0,
  discount_percent_gold: 0,
  discount_nominal_gold: 0,
  discount_percent_platinum: 0,
  discount_nominal_platinum: 0,
  discount_percent_gold: 0,
  discount_nominal_gold: 0,
  discount_percent_platinum: 0,
  discount_nominal_platinum: 0,
  is_nego:0,
  discount_percent_nego:0,
  product_fee: 0,
  code: "",
  product_length: "",
  product_width: "",
  product_height: "",
  is_varian: '0',
  varian_arr:[]

});
export default {
  components:{
    varianTable
  },
  data() {
    return {
      biayaLayananList: [
        { value: 5, title: "5%" },
        { value: 10, title: "10%" },
        { value: 15, title: "15%" },
        { value: 20, title: "20%" }
      ],
      selectedCategoryArr: {
        product_category_id: "0",
        product_category_fee_minimum: "0"
      },
      title: "",
      image_alert: false,
      required: [
        v => !!v || "Wajib diisi",
        v => v.length >= 5 || "Minimal 5 karakter"
      ],
      nameRules: [
        v => !!v || "Nama produk tidak boleh kosong",
        v => v.length >= 5 || "Nama produk minimal 5 karakter"
      ],
      unitRules: [v => !!v || "Satuan produk tidak boleh kosong"],
      categoryRules: [v => !!v || "Kategori produk tidak boleh kosong"],
      valueRules: [v => !!v || "Nilai tidak boleh kosong"],
      priceRules: [v => !!v || "Harga produk tidak boleh kosong"],
      priceB2bRules: [
        v => !!v || "Harga produk tidak boleh kosong",
        () =>
          parseInt(this.produkInput.hargaB2b) <
          parseInt(this.produkInput.hargaSatuan) ||
          "Harga B2B harus lebih rendah daripada harga satuan"
      ],
      stockRules: [v => !!v || "Stok produk tidak boleh kosong"],
      weightUnitRules: [v => !!v > 0 || "Tidak boleh kosong"],
      weightRules: [v => parseInt(v) > 0 || "Tidak boleh kosong"],
      imgPreview: [],
      produkInput: defaultInput(),
      units: ["unit", "pcs", "lembar", "kotak"],
      weightUnits: [
        { text: "Gram (g)", multiple: 1 }
        // { text: "Kilogram (Kg)", multiple: 1000 }
      ],
      isMobile: false,
      loadingProcess: false
    };
  },

  computed: {
    ...mapState('options', ['memberType']),
    ...mapState("category", ["category"]),
    ...mapState("productSeller", ["responseError", "detailProduct"]),
    ...mapState("storeSeller", ["detailStore"]),
    discountVariantMemberType(){
      return this.memberType.reduce((acc, item) => {
        acc['varian_discount_nominal_' + item.value] = 0 
        return acc
      },{})
    },
    defaultDiscountMemberType(){
      return this.memberType.reduce((acc, item) => {
        acc['discount_percent_' + item.value] = 0
        acc['discount_nominal_' + item.value] = 0
        return acc
      },{})
    },
    imgUbahProduct() {
      let img = [];
      for (var i = 0; i < 5; i++) {
        img[i] = this.detailProduct.product_image
          ? this.detailProduct.product_image[i]
          : undefined;
      }
      return img;
    }
  },

  
  methods: {
    calculateDiscountPercent(key){
      let hargaJual = this.produkInput.product_enable_discount == '1' ? this.produkInput.hargaSatuan : this.produkInput.product_gross
        if(this.produkInput.is_discount_tipe_member == '1' && this.produkInput.is_discount_tipe_member_percent == '1'){
          let discount = hargaJual - (hargaJual * this.produkInput[key] / 100)
          return discount.toLocaleString("id-ID", {
            style: "currency",
            currency: "IDR",
            minimumFractionDigits: 0
          }) 
        }else{
          let discount = hargaJual - (this.produkInput[key])
          return discount.toLocaleString("id-ID", {
            style: "currency",
            currency: "IDR",
            minimumFractionDigits: 0
          }) 
        }
    },
    checkVariantDiscount({index,key}){
      let check = Object.keys(this.discountVariantMemberType)
      if(!(key =='varian_price')) return
      let {is_discount_tipe_member,is_discount_tipe_member_percent,varian_arr} = this.produkInput
      let updateVarian = varian_arr[index]
      if(is_discount_tipe_member == '1' && is_discount_tipe_member_percent == '1'){
        // rumus : 
      }
      // if(!check.includes(key)) return 
      // console.log(index,key)
    },
    resetDiscountMember(){
      this.memberType.forEach(element => {
        this.produkInput['discount_percent_' + element.value] = 0
        this.produkInput['discount_nominal_' + element.value] = 0
      })
      if(this.produkInput.is_varian == '1'){
        // this.produkInput.varian_arr.forEach((item,index) => {
        //   this.produkInput.varian_arr[index] = { ...item, ...this.discountVariantMemberType}
        // })
        this.produkInput.varian_arr.forEach(v => {
          Object.keys(this.discountVariantMemberType).forEach(key => {
            v[key] = 0
          })
        })
      }
    },
    isEnableDiscountTypeMember(){
      if (this.produkInput.is_discount_tipe_member == 0) {
        this.produkInput.discount_percent_silver = 0;
        this.produkInput.discount_percent_gold = 0;
        this.produkInput.discount_percent_platinum = 0; 
      }
    },
    isEnableNego(){
      if (this.produkInput.is_nego == 0) {
        this.produkInput.discount_percent_nego = 0;  
      }
    },
    onSubmit(e) { 
        e.preventDefault() 
    },
    showTable(val){
      if(val == '1')
      this.produkInput.varian_arr = [
        defaultVarianArr()
      ]
      else{
        this.produkInput.varian_arr = []
      }
    },
    updateDataVariant({indexes,formApply}){ 
      indexes.forEach(index => {  
        if (formApply.varian_price) {
          this.produkInput.varian_arr[index].varian_price = formApply.varian_price;
        }
        if (formApply.varian_stock_quantity) {
          this.produkInput.varian_arr[index].varian_stock_quantity = formApply.varian_stock_quantity;
        }
        if (formApply.varian_code) {
          this.produkInput.varian_arr[index].varian_code = formApply.varian_code;
        }
        if (formApply.varian_weight) {
          this.produkInput.varian_arr[index].varian_weight = formApply.varian_weight;
        }
      });
    },
    removeDataVariant(indexes){  
      this.produkInput.varian_arr = this.produkInput.varian_arr.filter((_,i) => !indexes.includes(i));
    },
    getCategorySelected(id) {
      this.selectedCategoryArr = this.category.find(
        x => x.product_category_id === id
      );
      this.produkInput.product_fee =
        this.selectedCategoryArr.product_category_fee_minimum * 1;
      return this.selectedCategoryArr;
    },
    ...mapActions("category", ["getCategory"]),
    ...mapActions("productSeller", [
      "updateProduct",
      "updateProductB2b",
      "uploadImage",
      "getProductDetail",
      "removeProductImage"
    ]),
    ...mapActions("options", ["getTipeMember"]), 
    ...mapActions("storeSeller", ["getStoreDetail"]),
    ...mapMutations("productSeller", ["clearProduct"]),
    ...mapMutations(["makeAlert"]),
    isEnableDiscount() {
      if (this.produkInput.product_enable_discount == 0) {
        this.produkInput.product_discount_percent = 0;
        this.produkInput.product_discount_nominal = 0;
        this.calculatePrice();
      }
    },
    // changeDiscountType() {
    //   this.produkInput.product_discount_percent = 0;
    //   this.produkInput.product_discount_nominal = 0;
    // },
    calculatePrice() {
      if (this.produkInput.product_enable_discount == 1) {
        if (
          this.produkInput.product_discount_percent > 0 &&
          this.produkInput.product_discount_type == "percent"
        ) {
          if (this.produkInput.product_discount_percent > 70) {
            this.produkInput.product_discount_percent = 70;
          }
          this.produkInput.product_discount_nominal = Math.ceil(
            this.produkInput.product_gross *
            (this.produkInput.product_discount_percent / 100)
          );

          this.produkInput.hargaSatuan =
            this.produkInput.product_gross -
            this.produkInput.product_discount_nominal;
        } else {
          this.produkInput.hargaSatuan =
            this.produkInput.product_gross -
            this.produkInput.product_discount_nominal;
          this.produkInput.product_discount_percent = Math.ceil(
            (this.produkInput.product_discount_nominal /
              this.produkInput.product_gross) *
            100
          );
          if (this.produkInput.product_discount_percent > 70) {
            this.produkInput.product_discount_percent = 70;
            this.produkInput.product_discount_nominal = Math.ceil(
              this.produkInput.product_gross *
              (this.produkInput.product_discount_percent / 100)
            );
            this.produkInput.hargaSatuan =
            this.produkInput.product_gross -
            this.produkInput.product_discount_nominal;
          }
        }
      } else {
        this.produkInput.hargaSatuan = this.produkInput.product_gross;
      }
    },
    removeImage(index, url) {
      const lastSegment = url.split("/").pop();
      this.removeProductImage({
        filename: lastSegment
      }).then(() => {
        this.detailProduct.product_image.splice(index, 1);
      });
    },
    async openUpload() {
      const input = await document.getElementById("inputProdukImg");
      input.click();
    },
    createImage(event) {
      let imgLength = this.detailProduct.product_image.length;
      if (imgLength + event.length > 5)
        this.makeAlert({
          code: "error_response",
          type: "error",
          message: "Gambar maksimal 5",
          show: true
        });
      else {
        var dimensions = [];
        event.forEach(el => {
          dimensions.push(
            new Promise(resolve => {
              let formData = new FormData();
              formData.append("image", el);
              this.uploadImage(formData)
                .then(res => {
                  resolve(res.product_path);
                })
                .catch(() => {
                  this.loadingProcess = false;
                });
            })
          );
        });

        Promise.all(dimensions)
          .then(res => {
            this.detailProduct.product_image = [
              ...this.detailProduct.product_image,
              ...res
            ];
            this.update();
            if (imgLength > 0) this.image_alert = false;
          })
          .catch(function (err) {
            this.loadingProcess = false;
            console.log(err);
          });
      }
    },
    async update() {
      this.loadingProcess = await true;
      let image = await this.detailProduct.product_image.map(el => {
        return el.split("/").pop();
      });
      if (this.detailStore.store_is_b2b == "false") {
        let params = await {
          id: this.detailProduct.product_id,
          category_id: this.produkInput.kategori,
          code: this.produkInput.code,
          name: this.produkInput.nama,
          description: this.produkInput.deskripsi,
          price: this.produkInput.hargaSatuan,
          weight: this.produkInput.berat * this.produkInput.unitberat,
          unit: this.produkInput.unit,
          quantity: this.produkInput.stok,
          status: this.produkInput.status,
          image: image,
          product_gross: this.produkInput.product_gross,
          product_enable_discount: this.produkInput.product_enable_discount,
          product_discount_type: this.produkInput.product_discount_type,
          product_discount_percent: this.produkInput.product_discount_percent,
          product_discount_nominal: this.produkInput.product_discount_nominal,
          is_discount_tipe_member: this.produkInput.is_discount_tipe_member,
          is_discount_tipe_member_percent: this.produkInput.is_discount_tipe_member_percent, 
          discount_percent_silver:this.produkInput.discount_percent_silver,
          discount_nominal_silver:this.produkInput.discount_nominal_silver,
          discount_percent_gold:this.produkInput.discount_percent_gold,
          discount_nominal_gold:this.produkInput.discount_nominal_gold,
          discount_percent_platinum:this.produkInput.discount_percent_platinum,
          discount_nominal_platinum:this.produkInput.discount_nominal_platinum,
          is_nego: this.produkInput.is_nego,
          discount_percent_nego: this.produkInput.discount_percent_nego,
          product_fee: this.produkInput.product_fee,
          product_length: this.produkInput.product_length,
          product_width: this.produkInput.product_width,
          product_height: this.produkInput.product_height,
          is_varian: this.produkInput.is_varian,
          
              varian_arr: this.produkInput.varian_arr.map(el => {
                return {
                varian_name: el.varian_name,
                varian_stock_quantity: el.varian_stock_quantity,
                varian_weight: el.varian_weight,
                varian_price: el.varian_price,
                varian_code: el.varian_code,
                varian_status: el.varian_status,
                is_main: el.is_main,
                varian_image: el.varian_images ? el.varian_images.varian_image : '',  
                varian_discount_nominal_silver:el.varian_discount_nominal_silver,
                  varian_discount_nominal_gold:el.varian_discount_nominal_gold,
                  varian_discount_nominal_platinum:el.varian_discount_nominal_platinum
              }})
        };
       
        await this.updateProduct(params)
          .then(() => {
            this.$refs.formUpdateProduct.resetValidation();
            this.loadingProcess = false;
          })
          .catch(() => {
            this.loadingProcess = false;
          });
      } else if (this.detailStore.store_is_b2b == "true") {
        let params = {
          id: this.detailProduct.product_id,
          code: this.produkInput.code,
          description: this.produkInput.deskripsi,
          price: this.produkInput.hargaSatuan,
          price_original: this.produkInput.hargaB2b,
          weight: this.produkInput.berat * this.produkInput.unitberat,
          unit: this.produkInput.unit,
          quantity: this.produkInput.stok,
          status: this.produkInput.status,
          image: image,
          product_gross: this.produkInput.product_gross,
          product_enable_discount: this.produkInput.product_enable_discount,
          product_discount_type: this.produkInput.product_discount_type,
          product_discount_percent: this.produkInput.product_discount_percent,
          product_discount_nominal: this.produkInput.product_discount_nominal,
          is_discount_tipe_member: this.produkInput.is_discount_tipe_member,
          is_discount_tipe_member_percent: this.produkInput.is_discount_tipe_member_percent, 
          discount_percent_silver:this.produkInput.discount_percent_silver,
          discount_nominal_silver:this.produkInput.discount_nominal_silver,
          discount_percent_gold:this.produkInput.discount_percent_gold,
          discount_nominal_gold:this.produkInput.discount_nominal_gold,
          discount_percent_platinum:this.produkInput.discount_percent_platinum,
          discount_nominal_platinum:this.produkInput.discount_nominal_platinum,
          product_fee: this.produkInput.product_fee,
          is_nego: this.produkInput.is_nego,
          discount_percent_nego: this.produkInput.discount_percent_nego,
          product_length: this.produkInput.product_length,
          product_width: this.produkInput.product_width,
          product_height: this.produkInput.product_height,
          is_varian: this.produkInput.is_varian,
            varian_arr: this.produkInput.varian_arr.map(el => {
              return {
              varian_name: el.varian_name,
              varian_stock_quantity: el.varian_stock_quantity,
              varian_weight: el.varian_weight,
              varian_code: el.varian_code,
              varian_status: el.varian_status,
              is_main: el.is_main,
              varian_image: el.varian_images ? el.varian_images.varian_image : '',
              varian_discount_nominal_silver:el.varian_discount_nominal_silver,
                  varian_discount_nominal_gold:el.varian_discount_nominal_gold,
                  varian_discount_nominal_platinum:el.varian_discount_nominal_platinum
            }})
        };
        await this.updateProductB2b(params)
          .then(() => {
            this.$refs.formUpdateProduct.resetValidation();
            this.loadingProcess = false;
          })
          .catch(() => {
            this.loadingProcess = false;
          });
      }
    },
    cancelForm() {
      this.$router.push("/seller/produk-saya");
    },
    toggleAlert(val) {
      this.image_alert = val;
    },
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    }
  },
  created() {
    this.$store.dispatch("setPageTitle", `Ubah Produk Saya`);
    this.getCategory();
    this.getTipeMember()
    this.getStoreDetail();
    let router = this.$route;
    this.title = "Ubah Produk";
    this.getProductDetail({
      id: router.params.id,
      slug: router.params.slug
    })
      .then(() => {
        this.produkInput.product_gross = this.detailProduct.product_gross;
        if (this.produkInput.product_gross == 0) {
          this.produkInput.product_gross = this.detailProduct.product_price;
        }
        this.produkInput.product_enable_discount = this.detailProduct.product_enable_discount;
        this.produkInput.product_discount_type = this.detailProduct.product_discount_type;
        if (
          this.produkInput.product_discount_type == "" ||
          this.produkInput.product_discount_type == null
        ) {
          this.produkInput.product_discount_type = "nominal";
        }
        this.produkInput.product_discount_percent = this.detailProduct.product_discount_percent;
        this.produkInput.product_discount_nominal = this.detailProduct.product_discount_nominal;
        this.produkInput.product_fee = parseInt(this.detailProduct.product_fee);
        // console.log("this.produkInput.product_fee",this.produkInput.product_fee)
        if (parseFloat(this.produkInput.product_fee) < 5) {
          this.produkInput.product_fee = 5;
        }
        this.produkInput.code = this.detailProduct.product_code;
        this.produkInput.nama = this.detailProduct.product_name;
        this.produkInput.slug = this.detailProduct.product_slug_name;
        this.produkInput.kategori = this.detailProduct.product_category_id;
        this.produkInput.deskripsi = this.detailProduct.product_description;
        this.produkInput.hargaSatuan = this.detailProduct.product_price;
        this.produkInput.hargaB2b = this.detailProduct.b2b_product_price_original;
        this.produkInput.status = this.detailProduct.product_is_active;
        this.produkInput.stok = this.detailProduct.store_stock_quantity;
        this.produkInput.is_discount_tipe_member = this.detailProduct.is_discount_tipe_member;
        // this.produkInput.discount_percent_gold = this.detailProduct.discount_percent_gold;
        // this.produkInput.discount_percent_silver = this.detailProduct.discount_percent_silver;
        // this.produkInput.discount_percent_platinum = this.detailProduct.discount_percent_platinum;
        this.produkInput.is_nego = this.detailProduct.is_nego;
        this.produkInput.discount_percent_nego = this.detailProduct.discount_percent_nego;
        this.produkInput.berat = this.detailProduct.product_weight;
        this.produkInput.product_length = this.detailProduct.product_length;
        this.produkInput.product_width = this.detailProduct.product_width;
        this.produkInput.product_height = this.detailProduct.product_height;
        this.produkInput.unitberat =
          this.detailProduct.product_weight >= 1000 ? 1 : 1;
        if(!this.units.includes(this.detailProduct.product_unit)){
          this.units.push(this.detailProduct.product_unit)
        }
        this.produkInput.unit = this.detailProduct.product_unit;
        this.produkInput.is_varian = this.detailProduct.is_varian;
        this.produkInput.is_discount_tipe_member_percent = this.detailProduct.is_discount_tipe_member_percent 
        if(this.detailProduct.is_varian == '1'){
          this.produkInput.varian_arr = this.detailProduct.varian.map(el => {
          return {
            ...el,
            varian_status : el.varian_status == '1' ? 'active':'inactive',
            varian_images:{
              varian_image_url:el.varian_image_url,
              varian_image:el.varian_image
            },
            varian_discount_nominal_silver:el.varian_discount_nominal_silver,
            varian_discount_nominal_gold:el.varian_discount_nominal_gold,
            varian_discount_nominal_platinum:el.varian_discount_nominal_platinum,
          }
        });
        }else{
          this.produkInput.varian_arr = []
        }
        setTimeout(() => {
        this.produkInput.discount_percent_silver = this.detailProduct.discount_percent_silver
        this.produkInput.discount_nominal_silver = this.detailProduct.discount_nominal_silver
        this.produkInput.discount_percent_gold = this.detailProduct.discount_percent_gold
        this.produkInput.discount_nominal_gold = this.detailProduct.discount_nominal_gold
        this.produkInput.discount_percent_platinum = this.detailProduct.discount_percent_platinum
        this.produkInput.discount_nominal_platinum = this.detailProduct.discount_nominal_platinum
        }, 300);
        // console.log("produk", this.detailProduct);
      })
      .catch((err) => {
        console.log(err)
        setTimeout(() => {
          this.$router.push({ name: "seller-produk" });
        }, 3000);
      });
  },
  beforeDestroy() {
    this.clearProduct();
  }
};
</script>

<style lang="scss" scoped>
.table {

  th,
  td {
    padding: 15px;
  }
}

.product-img {
  border: 2px solid green;
  border-radius: 4px;

  &.emptyImg {
    border: 2px solid #ddd;
  }
}

.product-img {
  position: relative;

  .close-btn {
    position: absolute;
    top: -15px;
    right: -15px;
    height: 28px;
    width: 28px;
  }
}
</style>
